import { Button, Col, Row, Skeleton } from "antd";
import moment from "moment";
import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { Getnotifications } from "../../Config/API/notifications";
import FadeInImage from "../Images/FadeInImage";
import { fallbackprofile, getuserlink } from "../Utils";
import { checkProfileImage, get, textChecks } from "./function";

function NotificationScreen() {
  const [loading, setloading] = useState(true);
  const [notifications, setNotifications] = useState([]);
  const [activeTab, setActiveTab] = useState("all");
  const [isMobile, setIsMobile] = useState(window.innerWidth < 768);
  const navigate = useNavigate();

  useEffect(() => {
    get(setloading, Getnotifications, setNotifications, {
      category: activeTab === "all" ? "" : activeTab
    });

    const handleResize = () => {
      setIsMobile(window.innerWidth < 768);
    };

    window.addEventListener("resize", handleResize);

    return () => {
      setNotifications([]);
      setloading(null);
      window.removeEventListener("resize", handleResize);
    };
  }, [activeTab]);

  const tabs = ["all", "member", "notification", "discussion", "event", "wallet"];

  const handleChange = (name, value) => {
    setActiveTab(value);
  };

  const NotificationsList = () => (
    <div
      style={{
        width: "100%",
        margin: "0px auto",
        backgroundColor: "#fff"
      }}>
      {loading ? (
        Array(5)
          .fill()
          .map((_, index) => (
            <div
              key={index}
              style={{
                padding: isMobile ? "10px 15px" : "10px 40px",
                borderBottom: "1px solid #f0f0f0"
              }}>
              <Skeleton avatar title paragraph={{ rows: 1 }} active />
            </div>
          ))
      ) : notifications.length === 0 ? (
        // Empty state
        <div style={{ textAlign: "center", padding: "20px" }}>No notifications found</div>
      ) : (
        // Notifications list
        notifications.map((item, index) => (
          <div
            key={index}
            className="notification-item"
            style={{
              display: "flex",
              alignItems: "flex-start",
              padding: isMobile ? "10px 15px" : "10px 40px",
              borderBottom: "1px solid #f0f0f0"
            }}>
            <div
              onClick={() => navigate(getuserlink(item)?.url, { state: getuserlink(item)?.name })}
              style={{
                cursor: "pointer",
                marginTop: "10px",
                marginRight: "10px"
              }}>
              <FadeInImage
                type={"Fadenavprofile"}
                radiusAll
                fallaback={fallbackprofile}
                src={checkProfileImage(item)}
              />
            </div>

            <div style={{ flex: 1 }}>
              <div style={{ padding: "10px 5px 0 5px" }}>
                {textChecks(item, navigate, setloading, setNotifications)}
              </div>
              <div style={{ color: "#A5ACB8", fontSize: "12px", marginTop: "5px" }}>
                <small>{moment(item?.createdAt).fromNow()}</small>
              </div>
            </div>
          </div>
        ))
      )}
    </div>
  );

  const MobileView = () => (
    <div style={{ marginTop: "20px" }}>
      <div
        style={{
          padding: "0px 15px",
          position: "fixed",
          background: "white",
          zIndex: "999",
          top: "65px",
          width: "100%"
        }}>
        <h1>Notifications</h1>
        {/* <div style={{ display: "flex", alignItems: "center", marginBottom: "8px" }}>
          <Input.Search
            placeholder="Search Notification"
            style={{ flex: 1 }}
            onChange={(e) => {
              handleChange("search", e);
            }}
          />
          <BsFilterCircle
            style={{ marginLeft: "10px" }}
            fontSize={"1.6rem"}
            cursor="pointer"
            onClick={() => setIsFilterVisible(true)}
          />
        </div> */}

        <div
          style={{
            display: "flex",
            overflowX: "auto",
            marginBottom: "10px",
            WebkitOverflowScrolling: "touch",
            msOverflowStyle: "-ms-autohiding-scrollbar",
            scrollbarWidth: "none"
          }}
          className="tab-scrollbar">
          {tabs.map((tab) => (
            <Button
              key={tab}
              style={{
                borderRadius: "20px",
                marginRight: "10px",
                flexShrink: 0,
                whiteSpace: "nowrap",
                backgroundColor: activeTab === tab ? "#1890ff" : "#fff",
                color: activeTab === tab ? "#fff" : "inherit",
                border: activeTab === tab ? "none" : "1px solid #d9d9d9"
              }}
              onClick={() => handleChange("notificationType", tab)}>
              {tab.charAt(0).toUpperCase() + tab.slice(1)}
            </Button>
          ))}
        </div>
      </div>
      <div style={{ marginTop: "106px" }}>
        <NotificationsList />
        {/* <Modal
        title="Filters"
        open={isFilterVisible}
        onCancel={() => setIsFilterVisible(false)}
        footer={null}
        width={320}>
        <div style={{ marginBottom: "15px" }}>
          <Space style={{ display: "flex", justifyContent: "space-between", width: "100%" }}>
            <Button
              type="link"
              style={{ padding: 0 }}
              onClick={() => handleChange("markAllAsRead")}>
              Mark all as read
            </Button>
            <Button type="link" style={{ padding: 0 }} onClick={() => handleChange("deleteAll")}>
              Delete All
            </Button>
          </Space>
        </div>

        <h3>Date</h3>
        <div style={{ marginBottom: "15px" }}>
          <DatePicker
            style={{ width: "100%" }}
            value={date}
            onChange={(e) => handleChange("date", e)}
            format="DD/MM/YYYY"
          />
        </div>

        <h3>Type of Messages</h3>
        <div style={{ marginBottom: "20px" }}>
          <Checkbox
            checked={messageType === "all"}
            onChange={(e) => handleChange("all", e.target.checked)}>
            All
          </Checkbox>
          <br />
          <Checkbox
            checked={messageType === "unread"}
            onChange={(e) => handleChange("unread", e.target.checked)}>
            Unread
          </Checkbox>
          <br />
          <Checkbox
            checked={messageType === "read"}
            onChange={(e) => handleChange("read", e.target.checked)}>
            Read
          </Checkbox>
        </div>
      </Modal> */}
      </div>
    </div>
  );

  const WebView = () => (
    <Row justify="center" className="rowPadding">
      <Col
        xs={{ span: 24, order: 1 }}
        sm={{ span: 24, order: 1 }}
        md={{ span: 24, order: 1 }}
        lg={{ span: 6, order: 1 }}
        style={{ padding: "0 15px", marginTop: "42px" }}>
        <div
          style={{
            border: "1px solid #f0f0f0",
            borderRadius: "8px",
            background: "#ffffff",
            padding: "20px",
            marginBottom: "20px"
          }}>
          <h2>Filters</h2>
          {/* <div style={{ display: "flex", justifyContent: "space-between", marginBottom: "15px" }}>
            <Button
              type="link"
              style={{ padding: 0 }}
              onClick={() => handleChange("markAllAsRead")}>
              Mark all as read
            </Button>
            <Button type="link" style={{ padding: 0 }} onClick={() => handleChange("deleteAll")}>
              Delete All
            </Button>
          </div>

          <h3>Date</h3>
          <div style={{ marginBottom: "15px" }}>
            <DatePicker
              style={{ width: "100%" }}
              value={date}
              onChange={(e) => handleChange("date", e)}
              format="DD/MM/YYYY"
            />
          </div> */}

          <div
            style={{
              display: "flex",
              flexDirection: "column",
              gap: "10px",
              alignItems: "center",
              marginBottom: "20px"
            }}>
            {tabs.map((tab) => (
              <Button
                key={tab}
                style={{
                  width: "100%",
                  maxWidth: "350px",
                  borderRadius: "20px",
                  backgroundColor: activeTab === tab ? "#1890ff" : "#fff",
                  color: activeTab === tab ? "#fff" : "inherit",
                  border: (activeTab === tab) === "Notifications" ? "none" : "1px solid #d9d9d9"
                }}
                onClick={() => handleChange("notificationType", tab)}>
                {tab.charAt(0).toUpperCase() + tab.slice(1)}
              </Button>
            ))}
          </div>
          {/* <h3>Type of Messages</h3>
          <div>
            <Checkbox
              checked={messageType === "all"}
              onChange={(e) => handleChange("all", e.target.checked)}>
              All
            </Checkbox>
            <br />
            <Checkbox
              checked={messageType === "unread"}
              onChange={(e) => handleChange("unread", e.target.checked)}>
              Unread
            </Checkbox>
            <br />
            <Checkbox
              checked={messageType === "read"}
              onChange={(e) => handleChange("read", e.target.checked)}>
              Read
            </Checkbox>
          </div> */}
        </div>
      </Col>

      <Col
        xs={{ span: 24, order: 3 }}
        sm={{ span: 24, order: 3 }}
        md={{ span: 24, order: 3 }}
        lg={{ span: 11, order: 2 }}>
        <h1>Notifications</h1>

        {/* <div style={{ marginBottom: "20px" }}>
          <Input.Search
            placeholder="Search Notification"
            style={{ width: "100%" }}
            onChange={(e) => {
              handleChange("search", e);
            }}
          />
        </div> */}

        <NotificationsList />
      </Col>

      <Col
        xs={{ span: 24, order: 2 }}
        sm={{ span: 24, order: 2 }}
        md={{ span: 24, order: 2 }}
        lg={{ span: 6, order: 3 }}
        style={{ padding: "0 15px", marginTop: "42px" }}>
        {/* Optional right column content */}
      </Col>
    </Row>
  );

  return isMobile ? <MobileView /> : <WebView />;
}

export default NotificationScreen;
